var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "admin_panel_settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.852 12.852q0.273 0 0.574 0.027t0.574 0.082v-5.633l-8.75-3.828-8.75 3.828v5.742q0 1.969 0.656 3.828t1.832 3.418 2.789 2.652 3.473 1.531q0.492-0.109 0.957-0.273t0.902-0.383q-0.602-0.82-0.93-1.859t-0.328-2.133q0-1.969 0.93-3.555t2.516-2.516 3.555-0.93zM19.852 15.148q-1.313 0-2.379 0.629t-1.695 1.695-0.629 2.379q0 1.258 0.629 2.324t1.695 1.695 2.379 0.629q1.258 0 2.324-0.629t1.695-1.695 0.629-2.324q0-1.313-0.629-2.379t-1.695-1.695-2.324-0.629zM19.852 16.789q0.547 0 0.93 0.383t0.383 0.93q0 0.492-0.41 0.902t-0.902 0.41q-0.547 0-0.93-0.41t-0.383-0.902q0-0.547 0.383-0.93t0.93-0.383zM19.852 23.023q-0.82 0-1.504-0.355t-1.121-1.012q0-0.383 0.492-0.684t1.094-0.438 1.039-0.137q0.383 0 1.012 0.137t1.094 0.438 0.465 0.684q-0.438 0.656-1.094 1.012t-1.477 0.355z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.378d18ed5bb1a8aee40471c97d8a24b1.svg";
export { ForwardRef as ReactComponent };